/* eslint-disable filenames/match-regex */
import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { has, snakeCase } from 'lodash';
import { MultiSelect } from 'global/types';

export function isLoading({ currentSavedSearch, triedLoadingContext }: any) {
  return currentSavedSearch.isLoading || !triedLoadingContext;
}

export function isReady({ currentSavedSearch }: any) {
  return !currentSavedSearch.isProcessing && currentSavedSearch.isSuccessed;
}

export function isSplitView({ searchResults }: any) {
  return searchResults.appView === searchResults.appViews.SPLIT;
}

type Props = {
  searchResults: {
    appView: String, 
    appViews: {
      SPLIT: String,
      SINGLE: String
    }
  },
  resetReviewJob: Function,
  resetHoldReasonsjob: Function,
  showSuccessFlash: Function,
  showFailureFlash: Function,
  params: {
    id: String
  },
  changeAppView: Function,
  resetResults: Function,
  multiSelect: MultiSelect,
}

export function stateLogic({
  searchRelatedJobs,
  isHoldReasonsJobRunning,
  VALID_FLASH_VIEWS,
}: any) {
  return (component: any) =>
    function SearchResultsStateLogic(props: Props) {
      const [triedLoadingContext] = React.useState(false);

      const onChangeAppView = React.useCallback(() => {
        const { appView, appViews } = props.searchResults;
        props.changeAppView(
          appView === appViews.SPLIT ? appViews.SINGLE : appViews.SPLIT,
        );
      }, [props.searchResults, props.changeAppView]);

      const checkBulkOperationStatuses = React.useCallback((searchId: String) => {
        const jobs = searchRelatedJobs(searchId);

        if (jobs.review && has(jobs.review, 'isSuccess')) {
          props.resetReviewJob(searchId);

          if (jobs.review.isSuccess) {
            props.showSuccessFlash(
              'bulk_operations',
              VALID_FLASH_VIEWS,
            );
          } else {
            props.showFailureFlash('bulk_operations', VALID_FLASH_VIEWS);
          }
        }

        if (jobs.holdReasons && has(jobs.holdReasons, 'isSuccess')) {
          props.resetHoldReasonsjob(searchId);

          if (jobs.holdReasons.isSuccess) {
            props.showSuccessFlash(
              'bulk_operations',
              VALID_FLASH_VIEWS,
            );
          } else {
            props.showFailureFlash('bulk_operations', VALID_FLASH_VIEWS);
          }
        }
      }, [props.resetReviewJob, props.resetHoldReasonsjob, props.showSuccessFlash, props.showFailureFlash]);

      return React.createElement(component, {
        ...props,
        triedLoadingContext,
        onChangeAppView,
        checkBulkOperationStatuses,
        isHoldReasonsJobRunning: isHoldReasonsJobRunning(props.params.id),
      });
    };
}
